import "./_common";
import { GlobalComponents, GlobalStores } from "../react_isomorphic/global";
import { SharingShowComponents, SharingShowStores } from "../react_isomorphic/sharing_show";
import { HeaderComponents, HeaderStores } from "../react_isomorphic/site_header";

import { merge } from "lodash";

window.ReactComponents = merge(
  {},
  GlobalComponents,
  HeaderComponents,
  SharingShowComponents
);

window.ReactStores = merge(
  {},
  GlobalStores,
  HeaderStores,
  SharingShowStores
);
